import React from 'react';
import AppLayout from '../components/app/AppLayout';
import FocusTimerPlaceholder from '../components/app/FocusTimerPlaceholder';

function FocusPage() {
  return (
    <AppLayout>
      <FocusTimerPlaceholder />
    </AppLayout>
  );
}

export default FocusPage;








